@let canReadTraining =
  can(RoleAction.Read, RolePermissionSubject.QualificationTraining);
@let canCreateTrainingAttachment =
  can(RoleAction.Create, RolePermissionSubject.QualificationTrainingAttachment);
@let canDeleteTrainingAttachment =
  can(RoleAction.Delete, RolePermissionSubject.QualificationTrainingAttachment);
<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="
      customHeader ? customHeader : ('general.attachments' | translate)
    "
    [nzActive]="canReadTraining === false ? false : active"
    [nzCollapsible]="
      (canReadTraining === false ? true : disabled) ? 'disabled' : undefined
    "
    nz-tooltip
    [nzTooltipTitle]="'general.no_permissions' | translate"
    [nzTooltipTrigger]="canReadTraining === false ? 'hover' : null"
  >
    @if (multipleTrainingsSelected) {
      <div class="attachment-upload-info attachment-upload-info--top">
        {{
          'page.training_qualifications.bulk_edit.modal.attachments.info'
            | translate
        }}
      </div>
    }
    <!-- https://gitlab.com/menlo79/wilson-backend/-/blob/main/apps/api-gateway/src/qualifications/user-qualification-attachments/user-qualification-attachments.controller.ts#L45 -->
    <nz-upload
      [(nzFileList)]="fileList"
      [nzBeforeUpload]="beforeUpload"
      [nzType]="'drag'"
      [nzMultiple]="true"
      [nzSize]="maxFileSizeInBytes"
      [nzFileType]="'image/jpeg,application/pdf'"
      [nzAccept]="'image/jpeg,application/pdf'"
      [nzDisabled]="
        canCreateTrainingAttachment === false ? true : disabledNzUpload
      "
      [ngClass]="{
        'disabled-nz-upload-list':
          canDeleteTrainingAttachment === false ? true : disabledFileList,
      }"
    >
      <span nz-icon nzType="upload"></span>
      {{ 'general.upload' | translate }}
    </nz-upload>
    <div class="attachment-upload-info attachment-upload-info--bottom">
      {{
        customInfo
          ? customInfo
          : ('user_qualifications.attachments.upload.info' | translate)
      }}
    </div>
  </nz-collapse-panel>
</nz-collapse>
